import ConfettiExplosion from "react-confetti-explosion"
const ConfettiZoneStudentOnboarding = ({isConfettiExplosion}) => {
    return (
        <div>
            <div className='student-onboarding-fall-2023__confetti-wrapper-left'>
                {isConfettiExplosion && <ConfettiExplosion />}
            </div>
            <div className='student-onboarding-fall-2023__confetti-wrapper-right'>
                {isConfettiExplosion && <ConfettiExplosion />}
            </div>
            <div className='student-onboarding-fall-2023__confetti-wrapper-left confetti-zone-1'>
                {isConfettiExplosion && <ConfettiExplosion />}
            </div>
            <div className='student-onboarding-fall-2023__confetti-wrapper-right confetti-zone-1'>
                {isConfettiExplosion && <ConfettiExplosion />}
            </div>
            <div className='student-onboarding-fall-2023__confetti-wrapper-left confetti-zone-2'>
                {isConfettiExplosion && <ConfettiExplosion />}
            </div>
            <div className='student-onboarding-fall-2023__confetti-wrapper-right confetti-zone-2'>
                {isConfettiExplosion && <ConfettiExplosion />}
            </div>
        </div>
    )
}
export default ConfettiZoneStudentOnboarding